import { convertEnumsToOptions } from "../scripts/scripts_types";

export enum CurrencyTypes {
    EUR = '€',
    YEN = '¥',
    USD = '$',
}

export const CurrencyEnumOptions = convertEnumsToOptions(CurrencyTypes, CurrencyTypes);
